import Loading from "component/Loading";
import { useLoginInfo } from "hook/loginInfo";
import { jwtDecode } from "jwt-decode";
import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api_commonFetch } from "util";

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const navigate = useNavigate();
    const date = new Date();
    const nextDate = new Date(date.getFullYear(), date.getMonth()+1, 0);
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        memberId : params.get('memberId') || ''
        , memberPw : params.get('memberPw') || ''
        , returnUrl : params.get("returnUrl") || ''
        , pageType : params.get('pageType') || 'app'
    });
    const [loading, setLoading] = useState(true);

    const fn_postForm = async ()=>{
        const url = process.env.REACT_APP_API_URL + '/member/loginAction'
        const form = document.postForm;
        const formData = new FormData(form);
        const jsonData = JSON.stringify(Object.fromEntries(formData));
        const config = {method : 'post', body : jsonData, headers : {'Content-Type' : 'application/json'}}

        if(form.memberId.value == ''){
            form.memberId.focus();
            await Swal.fire('아이디를 입력하여주시기 바랍니다.');
        }else if(form.memberPw.value == ''){
            form.memberPw.focus();
            await Swal.fire('비밀번호를 입력하여주시기 바랍니다.');
        }else{
            const data = await api_commonFetch(url, config);
            

            if(data.result>0){
                try{
                    window.location.href = 'myapp://loginSuccess?accessToken=' + data.accessToken + '&refreshToken=' + data.refreshToken;
                }catch(err){
                    console.log('app err : ', err);
                }finally{
                    sessionStorage.setItem('accessToken', data.accessToken);
                    window.location.href = '/food';
                }
            }else{
                await Swal.fire("계정을 확인하여주시기 바랍니다.");
            }

        }
    }

    useEffect(()=>{
        document.postForm.memberId.focus();
    }, []);

    return (
        <>
            <form name="postForm" onSubmit={(e)=>{fn_postForm(); e.preventDefault();}}>
                <input type="hidden" name="returnUrl" defaultValue={vo.returnUrl}/>
                <table className="table">
                    <colgroup>
                        <col style={{width:'25%'}}/>
                        <col style={{width:'75%'}}/>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>아이디</th>
                            <td>
                                <input type="text" name="memberId" defaultValue={vo.memberId}/>
                            </td>
                        </tr>
                        <tr>
                            <th>비밀번호</th>
                            <td>
                                <input type="password" name="memberPw" defaultValue={vo.memberPw} autoComplete="off"/>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div className='text-center'>
                    <button className="btn btn-primary">로그인</button>
                </div>
            </form>
        </>
    );

}